import { DEAL_STATUSES, formatDate, formatTime, type DealStatus } from '@erp/shared';
import { CalendarClock } from 'lucide-react';

import { Badge } from '../ui/badge.tsx';

const TONES = { open: 'info', won: 'success', lost: 'neutral' } as const;

export function DealStatusBadge({ status }: { status: DealStatus }) {
  return <Badge tone={TONES[status]}>{DEAL_STATUSES[status]}</Badge>;
}

export function StaleBadge() {
  return <Badge tone="warning">Estancado</Badge>;
}

/** The next pending activity, or a warning when an open deal has none (HU-CRM-12). */
export function NextActivity({
  deal,
  tz,
}: {
  deal: {
    status: DealStatus;
    nextActivity: { title: string; startsAt: string; allDay: boolean; overdue: boolean } | null;
  };
  tz: string | undefined;
}) {
  if (deal.status !== 'open') return null;
  const next = deal.nextActivity;
  if (!next) return <Badge tone="warning">Sin próxima actividad</Badge>;
  return (
    <span className="inline-flex min-w-0 items-center gap-1">
      <CalendarClock className="size-3.5 shrink-0" aria-hidden="true" />
      <span className="truncate">
        {next.title} · {formatDate(next.startsAt, tz)}
        {next.allDay ? '' : ` ${formatTime(next.startsAt, tz)}`}
      </span>
      {next.overdue && <Badge tone="danger">Vencida</Badge>}
    </span>
  );
}
